module.exports = __webpack_public_path__ + "media/images/iconLockClosed__okGreen--dark-a0307818355294b99a9c428a4e8f8040.png";